module.exports = __webpack_public_path__ + "media/images/buttons/browse_up-c35e5d3bc0b2c199dac44312dd76cf2d.png";